
import ChildSelector from '../ChildSelector.vue';
import ToolTip from '../../../components/ToolTip.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'AutoSpecifications',
	components: {
		ChildSelector,
		ToolTip,
	},
})
class AutoSpecifications extends Vue {
	@Prop({ type: Object as PropType<Record<string, string>[]>, required: true })
	attributes: Record<string, string>[];

	@Prop({ type: Object as PropType<Record<string, string>[]>, required: true })
	additionalAttributes: Record<string, string>[];

	@Prop({ type: String, required: false })
	title: string;

	get details() {
		return this.$store.state.details;
	}

	get singleSelectors() {
		return this.$store.state.singleValueSelectors;
	}

	get childSelectors() {
		return this.$store.state.childSelectors;
	}

	get isGroupUrl() {
		return this.$store.state.isGroupUrl;
	}

	get isMobile() {
		return this.$mq === 'pdp-mobile';
	}

	get product() {
		return this.$store.state.product;
	}

	get toolTipPosition() {
		return this.isMobile ? 'top' : 'left';
	}

	toolTipText(selector) {
		return 'Select an available ' + selector.selectorLabel.toLowerCase();
	}

	mounted() {

		// this should be an async function that awaits the call to selectProductAttributes
		// with a flat call to initDefaultFulfillment at the end, but IE blows up so this is how it has to be
		// for now (unless we configure babel correctly)

		if (this.details.isGroup && !this.isGroupUrl && this.childSelectors.length > 0) {
			return this.$store.dispatch('selectProductAttributes', this.product.blainNumber)
				.then(() => this.$store.dispatch('initDefaultFulfillment'));
		} else {
			return this.$store.dispatch('initDefaultFulfillment');
		}
	}
}

export default AutoSpecifications;
